export default "__VITE_ASSET__02a246c0__"